import { Box, Typography, Paper, IconButton, Button } from '@mui/material';
import { styled } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import MemberForm from './MemberForm';


const BlurContainer = styled(Box)(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backdropFilter: 'blur(8px)',
  backgroundColor: 'rgba(0, 0, 0, 0.3)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 9999,
}));

const PortraitBox = styled(Paper)(({ theme }) => ({
  width: '90%',
  maxWidth: 400,
  height: '80vh',
  borderRadius: theme?.spacing?.(2) ?? '16px',
  padding: theme?.spacing?.(4) ?? '32px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme?.shadows?.[5] ?? '0 2px 10px rgba(0,0,0,0.2)',
  backgroundColor: theme?.palette?.background?.paper ?? '#fff',
  position: 'relative',
}));


const ProfilePopup = ({ profileDetails, setProfileDetails, setChance, updateProfile,register }) => {
 const year = [
  'I','II','III','IV'
];
  const dept = ['MECH', 'EEE', 'ECE', 'CSE', 'CIVIL','IT'];

  const updateprofileDetails = (field, value) => {
    console.log(field,value);
    setProfileDetails((prev) => ({ ...prev, [field]: value }));
  };
  function handleClick(){
    // console.log('profile',profileDetails);
    updateProfile();
    setChance(false);
  }
  // console.log('hi','profile')

  return (
    <BlurContainer>
      <PortraitBox elevation={3}>
      {!register && 
        (<IconButton
          sx={{ position: 'absolute', top: 8, right: 8 }}
          onClick={() => setChance(false)}
        >
          <CloseIcon />
        </IconButton>)}

        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Complete Your Profile
        </Typography>

        <Box
          component="fieldset"
          sx={{ border: '2px solid black', borderRadius: 2, p: 2, mt: 2 }}
        >
          <Box
            component="legend"
            sx={{ fontWeight: 'bold', color: 'black' }}
          >
            Personal Details
          </Box>

          <MemberForm
          isSmall={true}
            data={profileDetails}
            onChange={updateprofileDetails}
            depts={dept}
            years={year}
            type={false}
          />
        </Box>

        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 'auto', borderRadius: 5 }}
          onClick={()=>handleClick()}
        >
          Done
        </Button>
      </PortraitBox>
    </BlurContainer>
  );
};

export default ProfilePopup;
